import { app } from '../../app.module'
class EventInfoFormCtrl {
  private scope: ng.IScope
  private eventName: string
  private description: string

  constructor($scope) {
    this.scope = $scope
    // 編集としてモーダルが呼ばれた際は、既存のタグをセットする
    this.scope.$on('setEventData', (event, eventData) => {
      this.eventName = eventData.eventName
      this.description = eventData.description
    })
  }

  /**
   * イベント名を送信する
   * @param  {string} eventName
   */
  public inputEventName(eventName: string) {
    this.scope.$emit('changeEventName', eventName)
  }

  /**
   * イベントの説明文を送信する
   * @param  {string} description
   */
  public inputDescription(description: string) {
    this.scope.$emit('changeEventDescription', description)
  }
}

app.component('eventInfoForm', {
  template: require('./event-info-form.pug')(),
  controller: EventInfoFormCtrl,
})
